<template>
  <div id="init-home-container" class="d-flex justify-center" v-if="show">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-main id="supermain">
      <!-- fluid = container can use full width; we constrain readability via v-col -->
      <v-container class="white black--text" id="home-container" fluid>
        <v-row justify="center">
          <!--
            Desktop: readable column (lg=8 ~ 2/3 width, xl=6 ~ 1/2 width)
            Mobile: full width (cols=12)
          -->
          <v-col cols="12" md="10" lg="8" xl="6">
                      <!-- Card 2 -->
            <v-card class="mt-4 mb-6" color="grey lighten-5" elevation="2">
              <v-card-title class="text-h6">
              General Suggestions or Comments
              </v-card-title>

              <v-card-text class="body-1">
As part of the Reno Police Department’s efforts to continually improve and seek input from 
those we serve, we value your feedback and suggestions on how we can provide a higher 
level of service. Please submit your thoughts using the following email address: 
<a href="mailto:askrpd@reno.gov">askrpd@reno.gov</a>.     </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-text class="body-1">
Como parte de los esfuerzos del Departamento de Policía de Reno para mejorar 
continuamente y recabar la opinión de las personas a las que servimos,
 valoramos sus comentarios y sugerencias sobre cómo podemos brindar un nivel de servicio más alto. 
 Por favor, envíe sus opiniones utilizando la siguiente dirección de correo electrónico:
 <a href="mailto:askrpd@reno.gov">askrpd@reno.gov</a>.

              </v-card-text>

              <!-- <v-card-actions class="pb-4">
                <v-spacer></v-spacer>
                <v-btn
                  class="white--text"
                  color="accent"
                  @click="go_comment"
                >
                  Fill Out Form
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions> -->
            </v-card>
            <!-- Card 1 -->
            <v-card class="mt-4" color="grey lighten-5" elevation="2">
              <v-card-title class="text-h6">
                Employee-Related Complaint
              </v-card-title>

              <v-card-text class="body-1">
                The Reno Police Department holds our employees to the highest
                standards of professional policing. We value dedication,
                integrity, innovation, honesty, and transparency. If you feel
                that one of our employees has not lived up to these core values
                in your interaction with them, please submit a complaint for
                review by using the button below .
              </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-text class="body-1">
                El Departamento de Policía de Reno exige a sus empleados los más
                altos estándares de profesionalismo policial. Valoramos la
                dedicación, la integridad, la innovación, la honestidad y la
                transparencia. Si considera que alguno de nuestros empleados no
                ha cumplido con estos valores fundamentales durante su
                interacción con él o ella, por favor, presente una queja para
                su utilizando el botón de abajo.
              </v-card-text>

              <v-card-actions class="pb-4">
                <v-spacer></v-spacer>
                <v-btn
                  class="white--text"
                  color="accent"
                  @click="go_complaint"
                >
                  Fill Out Form
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>


                        <!-- Card 3 -->
            <v-card class="mt-4 mb-6" color="grey lighten-5" elevation="2">
              <v-card-title class="text-h6">
  Service Now Requests
              </v-card-title>

              <v-card-text class="body-1">
To connect with additional City related services such as Parking or Code Enforcement, 
or to report issues in your neighborhood such as to report abandoned vehicles, graffiti, 
or other blight related concerns use the button below. 
              </v-card-text>

              <v-divider class="mx-4"></v-divider>

              <v-card-text class="body-1">
Para acceder a otros servicios municipales, como los de estacionamiento o control de normativas,
o para informar sobre problemas en su vecindario, como vehículos abandonados, grafitis
u otros problemas relacionados con el deterioro urbano, utilice el botón que aparece a continuación.
              </v-card-text>

              <v-card-actions class="pb-4">
                <v-spacer></v-spacer>
                <v-btn
                  class="white--text"
                  color="accent"
                  @click="go_service"
                >
                  GO to Services
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* Base */
#init-home-container {
  width: 100%;
}

#home-container {
  width: 100%;
  min-height: 84dvh;
  padding-left: 12px;
  padding-right: 12px;
}

/* Keep your existing deep padding overrides */
.results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
.recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 7px !important;
}

.alice {
  color: aliceblue;
}

/* Slightly more breathing room on larger screens */
@media (min-width: 768px) {
  #home-container {
    padding-left: 24px;
    padding-right: 24px;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";

export default {
  name: "Home",
  components: {},
  mixins: [bus_common],
  data() {
    return {
      show: false,
    };
  },
  watch: {
    "$store.state.user": function () {
      let self = this;
      this.init(self);
    },
  },
  methods: {
    go_service(){
//https://service.reno.gov/reno
 window.location.href = "https://service.reno.gov/reno/";
    },

    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },
    go_complaint() {
      this.$router.push("/complaint");

    },
    go_comment() {
  this.sw
      window.location.href = "https://pubcom.renopd.com/";
      // this.swall_it("Public Comment status ",
      //  "Public comments are still under development. Please try later. Thank you for your kind attention. ", 
      //  "success", null, null) ;
    },
    init(self) {
      this.show_loader(false);
      this.swall_diag(
        "IMPORTANT: PLEASE READ",
        "If you have an emergency please call or text 911.<br><br>Are you attempting to report a crime or file a police report online?",
        "warning",
        function () {
          window.open("https://www.renopd.com/report", "_self");
        },
        "Yes",
        "No",
        function () {
          self.show = true;
        }
      );
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
